<template>
    <div>
    
        <div :class="this.time < 0.2 * inittime ? 'timeouting' : ''" class="timer">
    
            <b-icon-clock font-scale="1.1"></b-icon-clock> {{ counter }}
    
        </div>
    
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    props: ["questionChanged", "questionTrackId"],
    data() {
        return {
            time: 0,
            counter: ``,
            alreadysubmitted: false,
            changed: false
        };
    },
    created() {

        let isPresentIndex = this.mode_config.visited.findIndex(x => x.trackid == this.questionTrackId)
        if (isPresentIndex != -1) {
            this.time = this.mode_config.visited[isPresentIndex].timeLeft

            // if(this.mode_config.visited[isPresentIndex].timeLeft == 0){
            //     this.timeElapsed()
            // }
        } else {
            this.time = this.inittime;
        }


        setInterval(this.countdown, 1000);

    },
    watch: {
        questionChanged() {

            this.changed = true
            let isPresentIndex = this.mode_config.visited.findIndex(x => x.trackid == this.questionTrackId)
            if (isPresentIndex != -1) {
                this.time = this.mode_config.visited[isPresentIndex].timeLeft
            } else {
                this.time = this.inittime;
            }

            // this.updateModeConfig();
        },
        changed() {

            let isPresentIndex = this.mode_config.visited.findIndex(x => x.trackid == this.questionTrackId)
            if (isPresentIndex != -1) {
                this.time = this.mode_config.visited[isPresentIndex].timeLeft
            } else {
                this.time = this.inittime;
            }
        },
        time() {

            this.$emit("makeFalse")
            this.changed = false
            let action = ''
            //console.log(oldval, newval)

            if (this.time == 0) {
                action = 'elapsed'
            } else {
                action = 'visited'
            }

            let modeConfig = {
                action,
                trackid: this.questionTrackId,
                timeLeft: this.time,
            }


            if (this.time >= 0) {
                this.addModeConfig(modeConfig)
            }
        }
    },

    methods: {
        ...mapActions("exam", ['addModeConfig']),

        countdown() {

            if (this.time == 0) {
                this.counter = "00:00";
                this.timeElapsed();
                //this.setAlreadysub();

            } else if (this.time > 0 && this.time < 3600) {
                const minutes = Math.floor(this.time / 60);
                let seconds = this.time % 60;

                seconds = seconds < 10 ? "0" + seconds : seconds;

                this.counter = `${minutes}:${seconds}`;
            } else if (this.time > 3600) {
                const hours = Math.floor(this.time / 3600);
                const minutes = Math.floor((this.time % 3600) / 60);
                let seconds = (this.time % 3600) % 60;

                seconds = seconds < 10 ? "0" + seconds : seconds;

                this.counter = `${hours}:${minutes}:${seconds}`;
            } else {
                this.counter = "00:00";
            }

            this.time = this.time - 1;

        },
        timeElapsed() {
            this.$emit("elapsed");
        },
    },
    computed: {
        ...mapState({
            inittime: (state) => state.exam.mode_config.eachtime,
            submitted: (state) => state.exam.submitted,
            alreadysub: (state) => state.exam.alreadysub,
            mode_config: (state) => state.exam.mode_config
        }),
    },
};
</script>

<style scoped>
.timer {
    color: #263056;
    font-size: 20px;
    font-weight: bolder;
}

@media (max-width: 999px) {
    .timer {
        font-size: 1rem;
    }
}

.timeouting {
    color: red;
    /* margin-left: 30px; */
    /* transform: scale(1.1); */
}
</style>
